import ClearIcon from 'ui/icons/ClearIcon';

import { Box, Chip, SxProps, Theme, useTheme } from '@mui/material';

export interface ChipListProps {
  list: Array<{ name: string | JSX.Element; id: string }>;
  classNames?: string;
  onDelete?: (id: string) => void;
}

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    root: {
      listStyle: "none",
      padding: 0,
      "& > li": {
        maxWidth: `calc(100% - ${theme.spacing(2)})`,
      },
    },
    item: {
      mx: 1,
      my: 1,
      [theme.breakpoints.down("md")]: {
        my: 0.5,
      },
    },
  };
};

export default function ChipList(props: ChipListProps) {
  const { list, classNames, onDelete } = props;

  const theme = useTheme();
  const styles = getStyles(theme);
  return (
    <Box mx={-1} component="ul" display="flex" flexWrap="wrap" sx={styles.root}>
      {list.map(
        (item: { name: string | JSX.Element; id: string }, index: number) => (
          <Box component="li" key={index} sx={styles.item}>
            <Chip
              clickable={false}
              className={classNames}
              label={item.name}
              onDelete={
                onDelete &&
                (() => {
                  onDelete(item.id);
                })
              }
              deleteIcon={
                <Box display="flex" alignItems="center" pb={0.2}>
                  <ClearIcon sx={{ fontSize: "1.1rem" }} />
                </Box>
              }
            />
          </Box>
        )
      )}
    </Box>
  );
}
